export default {
  cdnVersion: '7.45.0'
};